<template>
	<b-row class="mt-3">
		<b-col xl="12">
			<transition name="slide-fade">
				<div>
					<div class="text-center w-100">
						<b-icon
							icon="three-dots"
							class="text-center"
							animation="cylon"
							font-scale="4"
							v-if="loadingStatus"
						></b-icon>
					</div>
					<div class="mb-3" v-if="!loadingStatus">
						<div class="mt-3 mb-2 text-center">
							<base-button type="outline-success" size="sm" title="Refresh" v-on:click="smsActivityRefresh()" :loading="loadingStatus">
								<i v-if="!loadingStatus"  class="fa fa-sync"></i> Refresh
							</base-button>
						</div>
						<b-row>
							<b-col cols="12" xl="8" lg="7" md="7" sm="6">
								<b-form-group
									label=""
									label-for="per-page-select"
									label-cols-sm="0"
									label-cols-md="0"
									label-cols-lg="0"
									label-align-sm="center"
									label-size="sm"
									class="mb-2 per-page-select"
								>
								<label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
								<b-form-select
									id="per-page-select"
									class="diameter-report-select"
									v-model="perPage"
									:options="pageOptions"
									size="sm"
									v-on:input="changePageOption(perPage)"
								></b-form-select>
								</b-form-group>
							</b-col>
							<b-col cols="12" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
								<b-form-group
									label=""
									label-for="filter-input"
									label-align-sm="right"
									label-size="sm "
									class="mb-0 per-page-select"
								>
									<label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
									<b-input-group size="sm">
										<b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<div class="">
							<b-table
								striped
								hover
								:items="SessionData"
								:fields="SessionColumn"
								:current-page="currentPage"
								:filter="filter"
								:per-page="perPage"
								:filter-included-fields="filterOn"
								:sort-by.sync="sortBy"
								:sort-desc.sync="sortDesc"
								:sort-direction="sortDirection"
								head-variant="light"
								table-class="text-nowrap"
								class="data-management-table primary-table"
								sticky-header="true"
								thead-class="white"
								show-empty
								responsive
								small
								@filtered="onFiltered"
							>
								<template #cell(message)="row">
									<span class="nowrap">
										{{row.value}}
									</span>
								</template>
								<template #cell(reference)="row">
									<span class="nowrap">
										{{row.value}}
									</span>
								</template>
								<template #cell(date)="row">
									<span class="nowrap">
										{{row.value}}
									</span>
								</template>
							</b-table>
						</div>

						<b-row v-if="SessionData.length > 0" class="mt-4">
							<b-col >
								<p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
							</b-col>
							<b-col >
								<b-pagination
									class="flex-fill-custom pr-4 ml-3 justify-content-end"
									v-model="currentPage"
									:total-rows="totalRows"
									:per-page="perPage"
									size="sm"
								></b-pagination>
							</b-col>
						</b-row>
					</div>
				</div>
			</transition>
		</b-col>
	</b-row>
</template>

<script>
import searchDetailService from "../../common/api-services/search-details-service";
import searchDashboardService from "../../common/api-services/search-dashboard-service";
import pagination from '../../common/format/pagination'

export default {
	name: "SMS-Activity",
	data() {
		return {
			loadingStatus: true,
			SessionData: [],
			SessionColumn: [
				{key: "direction", label: "Direction", sortable: true, sortDirection: "desc"},
				{key: "sender", label: "Sender", sortable: true, sortDirection: "desc"},
				{key: "receiver", label: "Receiver", sortable: true, sortDirection: "desc"},
				{key: "message", label: "Message", sortable: true, sortDirection: "desc"},
				{key: "reference", label: "reference", sortable: true, sortDirection: "desc"},
				{key: "date", label: "Date", sortable: true, sortDirection: "desc"},
				{key: "status", label: "Status", sortable: true, sortDirection: "desc"},
			],
			totalRows: 0,
			currentPage: 1,
			perPage: 10,
			fromPage: 10,
			pageOptions: [10, 25, 50, 100],
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			filterOn: [],
		};
	},
	mounted() {
		this.$root.$on("SMSActivityDetail", res => {
			this.getTotalRows();
			this.loadingStatus = false;
			this.fetchSMSActivityData(res.list);
		});
		this.getTotalRows();
	},
	methods: {
		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},

		changePageOption(page) {
			this.getTotalRows();
		},

		fetchSMSActivityData(list) {
			if (list && list.length > 0) {
				list.sort((a, b) => {
					if (a.direction > b.direction) {
						return 1;
					} else if (a.direction < b.direction) {
						return -1;
					} else {
						return 0;
					}
				});
				this.SessionData = list;
				this.totalRows = this.SessionData.length;
			}
		},

		smsActivityRefresh() {
			this.loadingStatus = true;
			let imsi = window.location.href.split("/:")[1];
			if (imsi && imsi.split("?imsi=")[1].length === 15) {
				searchDashboardService.getSMSActivity(imsi.split("?imsi=")[1]).then(res => {
					this.loadingStatus = false;
					this.getTotalRows();
					this.fetchSMSActivityData(res.list);
				});
			} else {
				this.$router.push({name: "Search"});
			}
		},
		startPage() {
		   return pagination.startPageFunc(this.currentPage, this.perPage)
		}, 
		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
      	},
	},
};
</script>
